module.exports = __webpack_public_path__ + "static/media/dashboard_fast.ba95b7ba.png";